<template>
  <div class="login-container">
    <div class="login-card">
      <h3>تسجيل الدخول</h3>
      <form @submit.prevent="login">
        <div class="form-group">
          <label>رقم الهاتف</label>
          <input type="text" v-model="phone" class="form-control" required />
        </div>
        <div class="form-group">
          <label>كلمة المرور</label>
          <input type="password" v-model="password" class="form-control" required/>
        </div>
        <button class="btn btn-primary btn-block" :disabled="loading">
          {{ loading ? 'جاري الدخول...' : 'دخول' }}
        </button>
        <div v-if="error" class="text-danger mt-2">{{ error }}</div>
      </form>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LoginForm',
  data() {
    return {
      phone: '',
      password: '',
      loading: false,
      error: null,
    };
  },
  methods: {
    async login() {
      this.loading = true;
      this.error = null;
      try {
        const response = await this.$axios.post('/trainer/login', {
          phone: this.phone,
          password: this.password,
        });
        if (response.data.success) {
          localStorage.setItem('api_token', response.data.user.token);
          this.$router.push({ name: 'SearchPage' });
        } else {
          this.error = 'بيانات دخول خاطئة';
        }
      } catch (e) {
        this.error = e.response?.data?.message || 'حدث خطأ أثناء محاولة الدخول';
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped>
.login-container {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  background-color: #f5f5f5;
}

.login-card {
  background: white;
  padding: 40px;
  border-radius: 8px;
  box-shadow: 0 2px 10px rgba(0,0,0,0.1);
  width: 100%;
  max-width: 400px;
  direction: rtl;
  text-align: right;
}

.login-card h3 {
  margin-bottom: 30px;
  text-align: center;
}
</style>
